import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import './product-section.css';

const imagesPath = "/assets"

function ProductSection({ data, elementsByRow = 5, title }) {
  const navigate = useNavigate();

  const handleClick = ({ path }) => {
    if (path) {
      navigate(path);
    }
  };

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  const productRows = chunkArray(data.products, elementsByRow);


  return (
    <Box className="product-section">
      <Typography variant="h4" className="product-section__title">
        ✧ {title || data.title} ✧
      </Typography>
      <Box className="product-section__list">
        {productRows.map((row, rowIndex) => (
          <Box key={rowIndex} className={`product-section__row row_${data.customStyle}`} display="flex">
            {row.filter(product => product.status).map((product, index) => (
              <Box key={index} className="product-section__product">
                <Box
                  component="img"
                  src={`${imagesPath}/products/${product.image}`}
                  alt={product.name}
                  className="product-section__product-image"
                  onClick={() => handleClick({ path: product.link })}
                />
                <div className="product-section__product-content">
                  <Typography variant="h5" className="product-section__product-name">
                    {product.name} 
                    <br></br>
                    {product.description}
                  </Typography>

                  <button
                    type="button"
                    className="product-section__product-btn"
                    onClick={() => handleClick({ path: product.link })}
                  >
                    Ver productos
                  </button>
                </div>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default ProductSection;